import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

// Locale-aware navigation wrappers. Use these instead of next/link and
// next/navigation inside the app so hrefs auto-prefix the CURRENT locale
// (/it or /en) — no more hardcoded `/it/...` paths that snap EN users to IT.
//
//   import { Link } from '@/i18n/navigation';
//   <Link href="/preventivi/new" />   // → /it/preventivi/new or /en/preventivi/new
//
// `usePathname`/`useRouter` here are locale-agnostic: usePathname() returns the
// path WITHOUT the locale prefix, and router.push('/preventivi') keeps the
// current locale.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
